// Client for the LiveSwitch register-token endpoint.
//
// The endpoint decides who we are. It returns the identity the token was signed
// for, and the client must construct itself with exactly that - see
// Longview-Api docs/liveswitch-token.md.

import { endpoints } from '../config/endpoints';

export type LiveSwitchGrant = {
  token: string;
  gatewayUrl: string;
  applicationId: string;
  channelId: string;
  userId: string;
  deviceId: string;
  clientId: string;
  /** Whether this call should be recorded, decided in Global Config. */
  recording: boolean;
  expiresIn: number;
};

export async function requestLiveSwitchGrant(
  channelId: string,
  displayName: string,
): Promise<LiveSwitchGrant> {
  if (!endpoints.liveSwitchToken) {
    throw new Error('VITE_LIVESWITCH_TOKEN_URL is not set in this build.');
  }

  const response = await fetch(endpoints.liveSwitchToken, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ channelId, displayName }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error ?? `could not join the call (${response.status})`);
  }
  return response.json();
}
